import UsersStatsContainer from './UsersStats.jsx';

export default UsersStatsContainer;
